import { get } from 'lodash';

import { intlService } from '~/i18n/IntlService';
import { SearchItem, SearchType } from '~/redux/api/methods/evisearch';
import { RoutePathType } from '~/routing/enums';
import { HandlerName } from '~/utils/table';

import { getDocumentHandlers } from '../AdvancedSearch.utils';

export const getDocumentNameColumn = (
  document: SearchItem,
  onDocumentNameClick?: (document: SearchItem) => void,
  onNavigate?: (handlerId: number) => void,
) => {
  const handlers = getDocumentHandlers(document);
  const intl = intlService.getIntl();
  return handlers?.length ? (
    <HandlerName
      onNavigate={onNavigate}
      handlers={handlers}
      onClick={
        onDocumentNameClick ? () => onDocumentNameClick(document) : undefined
      }
    />
  ) : (
    intl.formatMessage({
      id: 'ResultsTableUtils.deletedDocument',
      defaultMessage: 'Deleted document',
      description: 'Text shown for deleted documents',
    })
  );
};

export const getStaticColumns = (
  entity: SearchType,
  onDocumentNameClick?: (document: SearchItem) => void,
  onNavigate?: (handlerId: number) => void,
) => {
  const intl = intlService.getIntl();
  const documentColumn = [
    {
      key: 'name_Document',
      title: intl.formatMessage({
        id: 'ResultsTableUtils.nameColumnTitle1',
        defaultMessage: 'Name',
        description: 'Column title for document name',
      }),
      minWidth: 'm',
      renderCell: (doc: SearchItem) =>
        getDocumentNameColumn(doc, onDocumentNameClick, onNavigate),
    },
  ];

  const ticketWorkflowColumn = [
    {
      key: 'name_Ticket',
      title: intl.formatMessage({
        id: 'ResultsTableUtils.nameColumnTitle2',
        defaultMessage: 'Name',
        description: 'Column title for ticket/workflow name',
      }),
      minWidth: 'm',
      cellType: 'link',
      mapCellProps: (item: SearchItem) => ({
        text: get(item, 'selected_field_values.name_Ticket.value[0]'),
        pathname:
          item.type === 'ticket'
            ? RoutePathType.WorkflowTicketsTicket.replace(':ticketId', item.id)
            : undefined,
        state: { isRedirect: true },
      }),
    },
  ];

  switch (entity) {
    case 'document':
      return documentColumn;

    case 'ticket':
    case 'workflow':
      return ticketWorkflowColumn;

    default:
      return [];
  }
};
